import React from "react";

import "./Logo.css";

const Logo = () => (
  <h1 className="Logo">
    Week<span>l</span>e
  </h1>
);

export default Logo;
